

export const Bio = {
  name: "Chand Basha Panyam",
  roles: [
    "Full Stack Developer",
    
    // "Programmer",
  ],
  description:
  "As a dedicated MERN stack developer, I thrive on tackling new challenges and continuously expanding my skill set. My passion for learning drives me to stay updated with the latest advancements in web development, ensuring that I deliver high-quality, efficient, and scalable solutions. ",
  github: "https://github.com/chand98489",
  resume:"https://drive.google.com/file/d/1gH_xrlK7MS7A81pBcZlI8f4aSjL8tZ-k/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/chand-basha-panyam-79a87a269/",
  insta: "https://www.instagram.com/chand.24x/",
  Mail:"mailto:chandpanyam54@gmail.com",

};

export const skills = [
  {
    title: "Frontend",
    skills: [
      
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Tailwind CSS",
        image:
"https://tse2.mm.bing.net/th?id=OIP.Y-BbFmqRsIQWzX5BWC4mNQAAAA&pid=Api&P=0&h=180",      },

      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Redux",
        image:
"https://tse4.mm.bing.net/th?id=OIP.yHO9EA1tfmLQoatRkVA4_AHaFj&pid=Api&P=0&h=180"      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "React.Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
     
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
     
     
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Postman",
        image:
          "https://tse4.mm.bing.net/th?id=OIP.4nQ_eYPvB34aXGsenmzxFAAAAA&pid=Api&P=0&h=180",
      },

      {
        name: "MySQL",
        image:
"https://tse4.mm.bing.net/th?id=OIP.urLHYMYPFxkcs6AC4Io9vwHaHa&pid=Api&P=0&h=180"      },
      {
        name: "Rest API",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmJoxiAXVIxedd5WnxL3yepJpACK2lmCSl9w&s",
      },
      
      
    ],
  },
  
 
  {
    title: "Others",
    skills: 
    [
      {
        name: "Java",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQfPubhH7QOXhY-TgYSBOTuvlT_ev-9SOJ3w&s",
      },
      {
        name: "Data Structures & Algorthims",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRj-l3xqeigzbmXAlyBRdkBBaFzcuLQgi1BoA&s",
      },
     
      {
        name: "SQL",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQt9ziR3N0W-lOmTIw5pU3G45b8duc-VJDdj4nGmWLCNCwryiT3COv9BeYVgPgVRD_ny_M&usqp=CAU",
      },
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "Computer Networks",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqjcAZwrmOHaurdUAV3L-ZgSiAh5CIP8PBxg&s",
      },
      {
        name: "Operating System",
        image:
         "https://cdn-icons-png.flaticon.com/512/2172/2172894.png",
      },
      {
        name: "DBMS",
        image:"https://png.pngtree.com/png-vector/20220519/ourmid/pngtree-database-administrator-dbms-software-data-center-admin-secure-system-vector-png-image_46356680.jpg",
      },
     
    
      
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.glassdoor.com/l/79/43/6b/4c/maang-technologies.jpg",
    role: "Fullstack Engineering Intern",
    company: "Maang Technologies Pvt. Ltd.",
    date: "May 2024 -August 2024",
    desc: "Working as remote developer.",
    skills: [
      "Java",
      "React",
      "JavaScript",
      "Express.js",
      "Node Js",
      "MongoDB",  
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 1,
    img: "https://evodigit.com/lovable-uploads/c635732e-aeee-426e-b673-44c2c87c472d.png",
    role: "Freelance Web Developer",
    company: "EvoDigit Technolgies",
    date: "Jan 2025",
    desc: "Worked on a startup project for a couple of weeks, successfully deploying the application on Vercel and configuring a custom domain for a professional online presence.",
    skills: [
      "React",
      "TypeScript",
      "Tailwind.css",
      "Supabase",  
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  }


];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPbOQPosTDvQfmxRcPa2U5CEDmQWOaL9zY-A&s",
    school: "Ragiv Gandhi University of Knowledge Technologies IIIT RK Valley, KADAPA",
    date: "Oct 2021 - MAY 2025",
    grade: "8.1 CGPA",
    desc: "I am currently pursuing a Bachelor's degree Final year in CSE at RK Valley , Kadapa. I have completed 6 semesters and have a CGPA of 8.1. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, DBMS, Operating Systems, and Computer Networks, among others.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPbOQPosTDvQfmxRcPa2U5CEDmQWOaL9zY-A&s",
    school: "Ragiv Gandhi University of Knowledge Technologies IIIT RK Valley, KADAPA",
    date: "sep 2019 - Aug 2021",
    grade: "9.4 CGPA",
    desc: "I completed my class 12th (MPC) education at RGUKT Rk Valley, Kadapa.Dankuni, where I studied Science with Computer Science.",
    degree: "PRE UNIVERSITY COURSE (PUC)",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMuCTap3HouYp7g2HGFmAD1yl4Eb3_8CVmXgiYdUTToTo61jyygGIF4B0mRTMU_dhlxB0&usqp=CAU",
    school: "Zilla Parishad High School Alvakonda (V), Sanjamala(M) , Nandyal (Dist), AP",
    date: "Apr 2019",
    grade: "10.0 CGPA",
    desc: "I completed my class 10 education at Z P High School, ALVAKONDA ,Nandyal.",
    degree: "SSC",
  },
];

export const projects = [
  {
    id: 9,
    title: "Hungry-Hub Mern Project",
    // date: "Jun 2023 - Jul 2023",
    description:
    "Hungry Hub is an online food delivery website developed with the MERN Stack.Features seamless food browsing and secure order placement with Dummy Braintree Payment integration.Admins can manage content, update items, organize categories, and set the status of user orders.Delivers seamless food ordering experience for both users and administrators.",
    image:
      "https://i.ytimg.com/vi/xR4wZPbYheA/maxresdefault.jpg",
    tags: [

      "React.js",
      "Node.js",
      "MONGO DB",
      "Express.js",
      "restAPI",
     
     
    ],
    category: "android app",
    github: "https://github.com/chandbasha24/Hungry-Hub-Mern-Stack",
    webapp: "https://hungry-hub-mern-stack.onrender.com/",
  },

  {
    id: 10,
    title: "EvoDigit Project",
    // date: "Jun 2023 - Jul 2023",
    description:
    "Developed a web application using React, TailwindCSS, Supabase, and Framer Motion to enhance UI/UX and functionality.",
    image:
      "https://evodigit.com/lovable-uploads/c635732e-aeee-426e-b673-44c2c87c472d.png",
    tags: [
      "React",
      "Tailwind.css",
      "Supabase",  
     
    ],
    category: "android app",
    github: "https://github.com/chandbasha24/EvoDigit-Glowfolio",
    webapp: "https://chand-basha24-evo-digit-glowfolio-project.vercel.app/",
  },

  {
    id: 14,
    title: "Social Media Task Mern",
    // date: "Jun 2023 - Jul 2023",
    description:
    "In the Project User can upload the username, social media handle acc, profile pic & the admin can view the all users details by using of admin credentials.",
    image:
      "https://img.oercommons.org/780x780/oercommons/media/courseware/lesson/image/A_hrAZgVD.jpeg",
    tags: [
      "React.js",
      "Node.js",
      "MONGO DB",
      "Express.js",
     
    ],
    category: "android app",
    github: "https://github.com/chandbasha24/social-media-task_mern",
    webapp: "https://drive.google.com/file/d/1Aaf53EIYR9J8f_jZYMcJQyYK3YWABqLC/view",
  },
  // {
  //   id: 0,
  //   title: "Dice Game ",
  //   // date: "Apr 2023 - May 2023",
  //   description:
  //     "dice game , guessing of number...",
  //   image:'https://media.istockphoto.com/id/183819034/photo/two-dices.jpg?s=612x612&w=0&k=20&c=sawA-Q6tAlmzm37EiFViPCr9AT3f-PnwCM8qXrQzR2w=',
  //   tags: ["React Js", "Styled Components"],
  //   category: "web app",
  //   github: "https://github.com/chandbasha24/Dice-Game-React",
  //   webapp: "https://dice-game-react-gamma.vercel.app/",
   
  // },
  {
    id: 1,
    title: "Weather App ",
    
    description: " created the weather website using the react .",
    image:
      "https://beebom.com/wp-content/uploads/2021/05/1.-Weather-default-Windows1.1.jpg",
          tags: [
      "React Js",
         "Weather API",
    ],
    category: "web app",
    github: "https://github.com/chandbasha24/Weather-App-React",
    webapp: "https://weather-app-react-one-psi.vercel.app/",
  },
  // {
  //   id: 10,
  //   title: "Lunacal Assignment React + Tailwind  ",
    
  //   description: " created the Web page  .",
  //   image: "https://i.ytimg.com/vi/XtNkcHyVQOY/maxresdefault.jpg",
  //         tags: [
  //     "React Js",
  //        "Tailwind.Css",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/chandbasha24/lunacal-assignment",
  //   webapp: "https://chandbasha24.github.io/lunacal-assignment/",
  // },

  {
    id: 20,
    title: "Relume Website UI",
    
    description: "I recreated the first screen of Relume's website in my own style. https://relume.io/",
    image: "https://tse4.mm.bing.net/th?id=OIP.-3J5VW06uZF1oVnvEZkfFAHaFj&pid=Api&P=0&h=180",
          tags: [
      "React.js",
         "Tailwind.CSS",
         "Framer Motion",
    ],
    category: "web app",
    github: "https://github.com/chandbasha24/CodeDale-Task",
    webapp: "https://chand-basha24-code-dale-task.vercel.app/",
  },

  // {
  //   id: 11,
  //   title: "Celebrare Frontend Assignment  ",
    
  //   description: " created the Web page using HTML , CSS, Js .",
  //   image: "https://cdn.dribbble.com/userupload/6957683/file/original-160f04571e69088762be22263fff1cad.png?resize=1200x900",
  //         tags: [
  //     "HTML",
  //        "CSS",
  //        "javaScript",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/chandbasha24/Celebrare_Assignment-Intern/",
  //   webapp: "https://chandbasha24.github.io/Celebrare_Assignment-Intern/",
  // },

  {
    id: 2,
    title: " Movie Web clone",
    description:
" developed the Basic UI of movie website using the HTML,CSS,JavaScript",   
     image:
      "https://github.com/chandbasha24/Responsive_Movie_Web_clone/blob/main/project_home.png?raw=true",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/chandbasha24/Responsive_Movie_Web_clone",
    // webapp: "https://brain-tumor.netlify.app/",
    
  },
  {
    id: 3,
    title: "Blog APP",
    // date: "Dec 2021 - Apr 2022",
    description:
     "created the blog website using the Mern Stack",
    image:
      "https://www.hubspot.com/hs-fs/hubfs/assets/hubspot.com/web-team/WBZ/Feature%20Pages/free-blog-maker/free-blog-maker-hero-en.webp?width=1030&name=free-blog-maker-hero-en.webp",
    tags: [ "React.js",
      "Node.js",
      "MONGO DB",
      "Express.js",
    ],
    category:"android app",
    github: "https://github.com/chandbasha24/BlogApp-Mern-Project",
    webapp: "https://github.com/chandbasha24/BlogApp-Mern-Project",
  },
  {
    id: 7,
    title: "A Scroll-Triggered Animation with ChatGPT",
    description:
          "developed my own style of motion art effects utilizing GSAP (GreenSock Animation Platform) & ScrollTrigger in React.  ",
    image:
      "https://ihatetomatoes.net/wp-content/uploads/2020/07/img_react-and-scrolltrigger.png",
    tags: ["React", "GSAP", "Scroll-trigger "],
    category: "web app",
    github: "https://github.com/chandbasha24/motion-art-effect_React",
    webapp: "https://chandbasha24.github.io/motion-art-effect_React/",
   
    
    
  },
//   {
//     id: 8,
//     title: "Tic Tac Toe Game",
//     description:
// " developed the Tic-Tac Toe game using the HTML,CSS,JavaScript",   
//      image:
//       "https://github.com/chandbasha24/Tic-Tac-Toe-Game/blob/main/Screenshot.png?raw=true",
//     tags: ["HTML", "CSS", "JavaScript"],
//     category: "web app",
//     github: "https://github.com/chandbasha24/Tic-Tac-Toe-Game",
//     // webapp: "https://brain-tumor.netlify.app/",
    
//   },
//   {
//     id: 10,
//     title: "Currency Converter",
//     description:
// " developed the  Currency Converter using the HTML,CSS,JavaScript, CurrencyAPI",   
//      image:
//       "https://github.com/chandbasha24/Currency-Converter/blob/main/Screenshot.png?raw=true",
//     tags: ["HTML", "CSS", "JavaScript,currency API"],
//     category: "web app",
//     github: "https://github.com/chandbasha24/Currency-Converter",
//     // webapp: "https://brain-tumor.netlify.app/",
    
//   },
//   {
//     id: 9,
//     title: "To-do App Assignment",
//     // date: "Jun 2023 - Jul 2023",
//     description:"The app allows users to create, update, and delete tasks, providing a simple, user-friendly interface for task management. The frontend is built using React.js, enabling dynamic rendering of the UI for adding and viewing tasks. It connects with the backend via Axios or Fetch API to handle API requests.",
//     image:
// "https://repository-images.githubusercontent.com/315986811/d74b3080-2f6a-11eb-960e-c405ce8cfc43",    tags: [
//       "React.js",
//       "Node.js",
//       "MONGO DB",
//       "Express.js",
//       "restAPI",
     
//     ],
//     category: "android app",
//     github: "https://github.com/chandbasha24/Todo-app-Assignment",
//     webapp: "https://drive.google.com/file/d/1VBFl63JJNjw6IbYDjZCDyx-MfpVkN97r/view",
//   },
 
 

 
  
 
];

export const TimeLineData = [
  { year: 2021, text: "Started my journey" },
  { year: 2022, text: "Worked as a freelance developer" },
  { year: 2023, text: "Founded JavaScript Mastery" },
  { year: 2024, text: "Shared my projects with the world" },
  { year: 2025, text: "Started my own platform" },
];
